import React from 'react'
import PropTypes from 'prop-types'
import {Flex, Text, Button, useMultiStyleConfig, Link as ChakraLink} from '@chakra-ui/react'
import {Link as RouterLink} from 'react-router-dom'
import {BrandLogoInverted} from '../icons'

const NewsletterFooterSection = ({subscribeGroup}) => {
    const styles = useMultiStyleConfig('Footer')
    // const [isDisclaimerChecked, setIsDisclaimerChecked] = React.useState(false)

    const isExternalUrl = !!subscribeGroup?.is_external_url

    const buttonProps = !subscribeGroup?.cta?.href
        ? {
              id: 'js-show-newsletter-popup',
          }
        : isExternalUrl
        ? {
              as: ChakraLink,
              isExternal: true,
              href: subscribeGroup?.cta?.href,
          }
        : {
              id: 'js-show-newsletter-popup',
              as: RouterLink,
              to: subscribeGroup?.cta?.href,
          }

    return (
        <Flex {...styles?.newsletter?.footerContainer}>
            <BrandLogoInverted {...styles?.newsletter?.brandLogo} />

            <Flex {...styles?.newsletter?.contentContainer}>
                <Flex {...styles?.newsletter?.textStack}>
                    <Text {...styles?.newsletter?.header}>{subscribeGroup?.title}</Text>

                    <Text {...styles?.newsletter?.subtitle}>{subscribeGroup?.subtitle}</Text>
                </Flex>

                <Button
                    variant="outline"
                    aria-label={`Subscribe to ${subscribeGroup?.title}`}
                    className="del-newsletter__button"
                    {...buttonProps}
                    {...styles?.newsletter?.button}
                >
                    {subscribeGroup?.cta?.title}
                </Button>
            </Flex>
        </Flex>
    )
}

NewsletterFooterSection.propTypes = {
    subscribeGroup: PropTypes.shape({
        title: PropTypes.string,
        subtitle: PropTypes.string,
        cta: PropTypes.shape({href: PropTypes.string, title: PropTypes.string}),
        is_external_url: PropTypes.bool,
    }),
}

export default NewsletterFooterSection
